export const LANGS = [
  { i18n: 'en', backend: 'en', autonym: 'English' },
  { i18n: 'zh-CN', backend: 'zhCn', autonym: '简体中文' },
  // { i18n: 'zh-TW', backend: 'zhTw', autonym: '繁體中文' },
  // { i18n: 'hi-IN', backend: 'india', autonym: 'हिन्दी' },
  // { i18n: 'ar', backend: 'ar', autonym: 'العربية' },
  // { i18n: 'de', backend: 'de', autonym: 'Deutsch' },
  // { i18n: 'es', backend: 'es', autonym: 'Español' },
  // { i18n: 'fr', backend: 'fr', autonym: 'Français' },
  // { i18n: 'ja-JP', backend: 'jp', autonym: '日本語' },
  // { i18n: 'ko-KR', backend: 'kr', autonym: '한국어' },
  // { i18n: 'th-TH', backend: 'th', autonym: 'ไทย' },
  // { i18n: 'vi-VN', backend: 'vn', autonym: 'Tiếng Việt' },
  // { i18n: 'ru', backend: 'ru', autonym: 'Русский' },
  // { i18n: 'ms-MY', backend: 'my', autonym: 'Bahasa Melayu' },
  // { i18n: 'pt-PT', backend: 'pt', autonym: 'Português (Portugal)' },
  // { i18n: 'pt-BR', backend: 'pt', autonym: 'Português (Brasil)' },
  // { i18n: 'tr', backend: 'tr', autonym: 'Türkçe' },
  // { i18n: 'fa', backend: 'fa', autonym: 'فارسی' },
  // { i18n: 'id-ID', backend: 'id', autonym: 'Bahasa Indonesia' },
  // { i18n: 'my-MM', backend: 'mm', autonym: 'ဗမာစာ' },
  // { i18n: 'ug', backend: 'ug', autonym: 'ئۇيغۇرچە' },
] as const

export type LocaleCode = (typeof LANGS)[number]['i18n']

export const FALLBACK_LANG: LocaleCode = 'en'

// 后端码映射集中定义，便于维护
export const BACKEND_LANG_MAP: Record<string, string> = Object.fromEntries(
  LANGS.map((x) => [x.i18n, x.backend]),
)
// 常见浏览器变体回退
BACKEND_LANG_MAP['en-US'] = BACKEND_LANG_MAP['en']

export function getUILangOptions() {
  return LANGS.map((x) => ({ value: x.i18n, label: x.autonym }))
}

export const supported = new Set<LocaleCode>(LANGS.map((x) => x.i18n))
